import {create} from 'zustand'

import {Style} from '@progyny/type/Style'

export type NavigationState = {
  hide?: boolean
  hideMenu?: boolean
  variant?: Style
}

export const initialNavigationState: NavigationState = {
  hide: true,
  hideMenu: true,
}

export const defaultNavigationState: NavigationState = {
  hide: false,
  hideMenu: false,
  variant: 'soft-blue',
}

export const logoNavigationState: NavigationState = {
  hide: false,
  hideMenu: true,
  variant: 'white',
}

interface NavigationStore extends NavigationState {
  mergeNav: (config: NavigationState) => void
  replaceNav: (config: NavigationState) => void
}

export const useNavigationStore = create<NavigationStore>()((set) => ({
  ...initialNavigationState,
  // Merges config into existing state (equivalent to the old 'set' action)
  mergeNav: (config) => set(config),
  // Replaces nav state entirely (equivalent to the old 'reset' action)
  replaceNav: (config) =>
    set({hide: undefined, hideMenu: undefined, variant: undefined, ...config}),
}))
